import types from '../store/types';
export const HandleModal = payload => ({ type: types.HANDLE_MODAL, payload });
